import Vue from 'vue';
import Router from 'vue-router';
import VueProgressiveImage from 'vue-progressive-image';
import VueCarousel from 'vue-carousel';
import VueLazyload from 'vue-lazyload';
import { VLazyImagePlugin } from 'v-lazy-image';

import Landing from '@/components/Landing';

Vue.use(VueProgressiveImage);
Vue.use(VueCarousel);
Vue.use(Router);
Vue.use(VueLazyload);
Vue.use(VLazyImagePlugin);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Landing',
      component: Landing,
      alias: ['/how-to', '/why', '/about'],
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js